<app-page-breadcrumb pageTitle="Contactos"></app-page-breadcrumb>

<div class="space-y-4">
  <!-- Compact Controls Section -->
  <div class="flex items-center justify-between gap-2 flex-wrap">
    <!-- Filtro rápido de responsable -->
    <div class="flex items-center rounded-lg border border-gray-200 dark:border-gray-700 overflow-hidden">
      <button
        type="button"
        (click)="setOwnerFilter('all')"
        class="px-3 py-1.5 text-sm font-medium transition-colors"
        [ngClass]="filtroIsActive && filtroOwner === 'all'
          ? 'bg-brand-500 text-white'
          : 'bg-white dark:bg-gray-800 text-gray-600 dark:text-gray-400 hover:bg-gray-50 dark:hover:bg-gray-700'">
        Todos
      </button>
      <button
        type="button"
        (click)="setOwnerFilter('mine')"
        class="px-3 py-1.5 text-sm font-medium transition-colors border-l border-gray-200 dark:border-gray-700"
        [ngClass]="filtroIsActive && filtroOwner === 'mine'
          ? 'bg-brand-500 text-white'
          : 'bg-white dark:bg-gray-800 text-gray-600 dark:text-gray-400 hover:bg-gray-50 dark:hover:bg-gray-700'">
        Mis contactos
      </button>
      <!-- inc38 — bandeja de los que entraron por un canal público y nadie ha reclamado.
           El literal es "Sin asignar", el mismo que muestra la ficha del contacto en
           Responsable: si el filtro dijera otra cosa el usuario no ataría los dos. -->
      <button
        type="button"
        (click)="setOwnerFilter('unassigned')"
        class="px-3 py-1.5 text-sm font-medium transition-colors border-l border-gray-200 dark:border-gray-700"
        [ngClass]="filtroIsActive && filtroOwner === 'unassigned'
          ? 'bg-brand-500 text-white'
          : 'bg-white dark:bg-gray-800 text-gray-600 dark:text-gray-400 hover:bg-gray-50 dark:hover:bg-gray-700'">
        Sin asignar
      </button>
      <button
        type="button"
        (click)="setInactivosFilter()"
        class="px-3 py-1.5 text-sm font-medium transition-colors border-l border-gray-200 dark:border-gray-700"
        [ngClass]="!filtroIsActive
          ? 'bg-warning-500 text-white'
          : 'bg-white dark:bg-gray-800 text-gray-600 dark:text-gray-400 hover:bg-gray-50 dark:hover:bg-gray-700'">
        Inactivos
      </button>
    </div>

    <!-- Right side - Action buttons -->
    <div class="flex items-center gap-1.5">
      <button
        type="button"
        (click)="toggleFilters()"
        class="px-3 py-1.5 text-sm rounded-lg font-medium transition-colors bg-gray-100 dark:bg-gray-800 text-gray-700 dark:text-gray-300 hover:bg-gray-200 dark:hover:bg-gray-700 flex items-center gap-1.5">
        <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 4a1 1 0 011-1h16a1 1 0 011 1v2.586a1 1 0 01-.293.707l-6.414 6.414a1 1 0 00-.293.707V17l-4 4v-6.586a1 1 0 00-.293-.707L3.293 7.293A1 1 0 013 6.586V4z"></path>
        </svg>
        {{ showFilters ? 'Ocultar' : 'Filtros' }}
      </button>
      <button
        type="button"
        (click)="vistaTablero()"
        class="px-3 py-1.5 text-sm rounded-lg font-medium transition-colors border border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-800 text-gray-700 dark:text-gray-300 hover:bg-gray-50 dark:hover:bg-gray-700 flex items-center gap-1.5">
        <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 17V7m0 10a2 2 0 01-2 2H5a2 2 0 01-2-2V7a2 2 0 012-2h2a2 2 0 012 2m0 10a2 2 0 002 2h2a2 2 0 002-2M9 7a2 2 0 012-2h2a2 2 0 012 2m0 10V7m0 10a2 2 0 002 2h2a2 2 0 002-2V7a2 2 0 00-2-2h-2a2 2 0 00-2 2"></path>
        </svg>
        Kanban
      </button>
      @if (canImportExport) {
        <button
          type="button"
          (click)="abrirImportExport()"
          title="Importar / exportar CSV de contactos"
          class="px-3 py-1.5 text-sm rounded-lg font-medium transition-colors border border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-800 text-gray-700 dark:text-gray-300 hover:bg-gray-50 dark:hover:bg-gray-700 flex items-center gap-1.5">
          <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 16v2a2 2 0 002 2h12a2 2 0 002-2v-2M7 10l5-5m0 0l5 5m-5-5v12"></path>
          </svg>
          Importar / Exportar
        </button>
      }
      <button
        type="button"
        *appHasPermission="'contacts:create'"
        (click)="nuevoContacto()"
        class="px-3 py-1.5 text-sm rounded-lg font-medium transition-colors bg-brand-500 text-white hover:bg-brand-600 flex items-center gap-1.5">
        <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 4v16m8-8H4"></path>
        </svg>
        Nuevo
      </button>
    </div>
  </div>

  <!-- Compact Filters Panel -->
  @if (showFilters) {
  <div class="bg-white dark:bg-gray-900 border border-gray-200 dark:border-gray-700 rounded-lg p-3">
    <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-3">
      <!-- Búsqueda por nombre, correo o teléfono -->
      <div>
        <label class="block text-xs font-medium text-gray-700 dark:text-gray-300 mb-1">
          Buscar por nombre, correo o teléfono
        </label>
        <input
          type="text"
          [(ngModel)]="filtroNombre"
          (ngModelChange)="buscar()"
          placeholder="Nombre, correo o número..."
          class="w-full px-2.5 py-1.5 text-sm border border-gray-300 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-800 text-gray-900 dark:text-white focus:ring-2 focus:ring-brand-500 focus:border-transparent">
      </div>

      <!-- Búsqueda por empresa -->
      <div>
        <label class="block text-xs font-medium text-gray-700 dark:text-gray-300 mb-1">
          Buscar por empresa
        </label>
        <input
          type="text"
          [(ngModel)]="filtroEmpresa"
          (ngModelChange)="buscar()"
          placeholder="Nombre de la empresa..."
          class="w-full px-2.5 py-1.5 text-sm border border-gray-300 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-800 text-gray-900 dark:text-white focus:ring-2 focus:ring-brand-500 focus:border-transparent">
      </div>

      <!-- Filtro Estado de Contacto -->
      <div>
        <label class="block text-xs font-medium text-gray-700 dark:text-gray-300 mb-1">
          Estado
        </label>
        <select
          [(ngModel)]="filtroContactState"
          (ngModelChange)="buscar()"
          class="w-full px-2.5 py-1.5 text-sm border border-gray-300 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-800 text-gray-900 dark:text-white focus:ring-2 focus:ring-brand-500 focus:border-transparent">
          <option [ngValue]="undefined">Todos</option>
          @for (state of contactStates; track state.id) {
          <option [ngValue]="state.id">{{ state.name }}</option>
          }
        </select>
      </div>

      <!-- Filtro Ciclo de Contacto -->
      <div>
        <label class="block text-xs font-medium text-gray-700 dark:text-gray-300 mb-1">
          Ciclo de Contacto
        </label>
        <select
          [(ngModel)]="filtroContactCycle"
          (ngModelChange)="buscar()"
          class="w-full px-2.5 py-1.5 text-sm border border-gray-300 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-800 text-gray-900 dark:text-white focus:ring-2 focus:ring-brand-500 focus:border-transparent">
          <option [ngValue]="undefined">Todos</option>
          @for (cycle of contactCycles; track cycle.id) {
          <option [ngValue]="cycle.id">{{ cycle.name }}</option>
          }
        </select>
      </div>

      <!-- Filtro Origen -->
      <div>
        <label class="block text-xs font-medium text-gray-700 dark:text-gray-300 mb-1">
          Origen
        </label>
        <select
          [(ngModel)]="filtroOrigin"
          (ngModelChange)="buscar()"
          class="w-full px-2.5 py-1.5 text-sm border border-gray-300 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-800 text-gray-900 dark:text-white focus:ring-2 focus:ring-brand-500 focus:border-transparent">
          <option [ngValue]="undefined">Todos</option>
          @for (origin of contactOrigins; track origin.id) {
          <option [ngValue]="origin.id">{{ origin.name }}</option>
          }
        </select>
      </div>

      <!-- Filtro País (por prefijo telefónico) -->
      <div>
        <label class="block text-xs font-medium text-gray-700 dark:text-gray-300 mb-1">
          País
        </label>
        <app-country-select
          [countries]="filterCountries"
          [value]="filtroPais"
          [clearable]="true"
          placeholder="Todos"
          (valueChange)="onCountryFilterChange($event)" />
      </div>

      <!-- Filtro por atributo custom (server-side JOIN, sin N+1) -->
      @if (attributeDefinitions.length > 0) {
      <div>
        <label class="block text-xs font-medium text-gray-700 dark:text-gray-300 mb-1">
          Atributo personalizado
        </label>
        <select
          [(ngModel)]="filtroAttributeDefinitionId"
          (ngModelChange)="onAttrDefChange()"
          class="w-full px-2.5 py-1.5 text-sm border border-gray-300 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-800 text-gray-900 dark:text-white focus:ring-2 focus:ring-brand-500 focus:border-transparent">
          <option [ngValue]="undefined">— Ninguno —</option>
          @for (def of attributeDefinitions; track def.id) {
            <option [ngValue]="def.id">{{ def.name }}</option>
          }
        </select>
      </div>

      @if (selectedAttrDef) {
      <div>
        <label class="block text-xs font-medium text-gray-700 dark:text-gray-300 mb-1">
          Valor de "{{ selectedAttrDef.name }}"
          <span class="ml-1 font-normal text-gray-400">
            @if (selectedAttrDef.type === 'text' || selectedAttrDef.type === 'list') { · parcial }
            @if (selectedAttrDef.type === 'number' || selectedAttrDef.type === 'boolean') { · exacto }
          </span>
        </label>

        @if (selectedAttrDef.type === 'list') {
          <select [(ngModel)]="filtroAttrValue" (ngModelChange)="buscar()"
            class="w-full px-2.5 py-1.5 text-sm border border-gray-300 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-800 text-gray-900 dark:text-white focus:ring-2 focus:ring-brand-500 focus:border-transparent">
            <option value="">Todos</option>
            @for (opt of parseListOptions(selectedAttrDef.listOptions); track opt) {
              <option [value]="opt">{{ opt }}</option>
            }
          </select>
        }
        @if (selectedAttrDef.type === 'boolean') {
          <select [(ngModel)]="filtroAttrValue" (ngModelChange)="buscar()"
            class="w-full px-2.5 py-1.5 text-sm border border-gray-300 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-800 text-gray-900 dark:text-white focus:ring-2 focus:ring-brand-500 focus:border-transparent">
            <option value="">Todos</option>
            <option value="true">Sí</option>
            <option value="false">No</option>
          </select>
        }
        @if (selectedAttrDef.type === 'text') {
          <input type="text" [(ngModel)]="filtroAttrValue" (ngModelChange)="buscar()"
            placeholder="Buscar texto..."
            class="w-full px-2.5 py-1.5 text-sm border border-gray-300 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-800 text-gray-900 dark:text-white focus:ring-2 focus:ring-brand-500 focus:border-transparent">
        }
        @if (selectedAttrDef.type === 'number') {
          <input type="number" [(ngModel)]="filtroAttrValue" (ngModelChange)="buscar()"
            placeholder="Valor exacto"
            class="w-full px-2.5 py-1.5 text-sm border border-gray-300 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-800 text-gray-900 dark:text-white focus:ring-2 focus:ring-brand-500 focus:border-transparent">
        }
      </div>
      }
      }

      <!-- Botón Limpiar Filtros -->
      <div class="flex items-end">
        <button
          type="button"
          (click)="limpiarFiltro()"
          class="w-full px-3 py-1.5 text-sm rounded-lg font-medium transition-colors bg-gray-100 dark:bg-gray-800 text-gray-700 dark:text-gray-300 hover:bg-gray-200 dark:hover:bg-gray-700">
          Limpiar Filtros
        </button>
      </div>
    </div>
  </div>
  }

  <!-- Loading -->
  @if (loading) {
  <div class="flex justify-center items-center py-12">
    <div class="animate-spin rounded-full h-8 w-8 border-b-2 border-brand-500"></div>
    <span class="ml-3 text-gray-500 dark:text-gray-400">Cargando contactos...</span>
  </div>
  }

  <!-- Error -->
  @if (error) {
  <div class="p-4 bg-error-50 border border-error-200 rounded-lg dark:bg-error-500/10 dark:border-error-500/20">
    <div class="flex items-center gap-3">
      <svg class="w-5 h-5 text-error-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
          d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"></path>
      </svg>
      <p class="text-error-600 dark:text-error-400">{{ error }}</p>
    </div>
  </div>
  }

  <!-- Barra de acciones masivas -->
  @if (!loading && !error && selectedContactIds.length > 0) {
  <div class="flex items-center justify-between gap-3 px-4 py-3 bg-brand-50 dark:bg-brand-900/20 rounded-xl border border-brand-100 dark:border-brand-800">
    <div class="flex items-center gap-2">
      <span class="flex h-6 w-6 items-center justify-center rounded-full bg-brand-500 text-xs font-bold text-white">
        {{ selectedContactIds.length }}
      </span>
      <span class="text-sm font-medium text-brand-700 dark:text-brand-400">contacto(s) seleccionado(s)</span>
    </div>
    <div class="flex gap-2">
      <button *appHasPermission="'contacts:edit'" (click)="openBulkActionModal('CHANGE_OWNER')"
        class="inline-flex items-center gap-1.5 px-3 py-1.5 bg-white dark:bg-gray-800 border border-brand-200 dark:border-brand-700 text-brand-600 dark:text-brand-400 text-xs font-medium rounded-lg hover:bg-brand-50 dark:hover:bg-brand-900/20 transition-colors">
        <svg class="w-3.5 h-3.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z"/>
        </svg>
        Cambiar responsable
      </button>
      @if (filtroIsActive) {
      <button *appHasPermission="'contacts:edit'" (click)="openBulkActionModal('ARCHIVE')"
        class="inline-flex items-center gap-1.5 px-3 py-1.5 bg-white dark:bg-gray-800 border border-amber-200 dark:border-amber-700 text-amber-600 dark:text-amber-400 text-xs font-medium rounded-lg hover:bg-amber-50 dark:hover:bg-amber-900/20 transition-colors">
        <svg class="w-3.5 h-3.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 8h14M5 8a2 2 0 110-4h14a2 2 0 110 4M5 8v10a2 2 0 002 2h10a2 2 0 002-2V8m-9 4h4"/>
        </svg>
        Inactivar
      </button>
      } @else {
      <button *appHasPermission="'contacts:delete'" (click)="openBulkActionModal('DELETE')"
        class="inline-flex items-center gap-1.5 px-3 py-1.5 bg-white dark:bg-gray-800 border border-red-200 dark:border-red-700 text-red-600 dark:text-red-400 text-xs font-medium rounded-lg hover:bg-red-50 dark:hover:bg-red-900/20 transition-colors">
        <svg class="w-3.5 h-3.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"/>
        </svg>
        Eliminar
      </button>
      }
    </div>
  </div>
  }

  <!-- Tabla de contactos -->
  @if (!loading && !error) {
  <div class="overflow-hidden rounded-xl border border-gray-200 bg-white dark:border-gray-800 dark:bg-white/[0.03]">
    <div class="max-w-full overflow-x-auto custom-scrollbar">
      <table class="min-w-full">
        <!-- Table Header -->
        <thead class="border-b border-gray-100 dark:border-white/[0.05]">
          <tr>
            <th class="px-5 py-3 w-12 text-center">
              <input type="checkbox"
                class="w-4 h-4 text-brand-500 bg-white border-gray-300 rounded focus:ring-brand-500 dark:border-gray-600 dark:bg-gray-700 cursor-pointer"
                [checked]="isAllContactsSelected"
                (change)="toggleAllContacts($event)">
            </th>
            <th class="px-5 py-3 font-medium text-gray-500 text-start text-theme-xs dark:text-gray-400">Nombre</th>
            <th class="px-5 py-3 font-medium text-gray-500 text-start text-theme-xs dark:text-gray-400">Email</th>
            <th class="px-5 py-3 font-medium text-gray-500 text-start text-theme-xs dark:text-gray-400">Teléfono</th>
            <th class="px-5 py-3 font-medium text-gray-500 text-start text-theme-xs dark:text-gray-400">Estado</th>
            <th class="px-5 py-3 font-medium text-gray-500 text-start text-theme-xs dark:text-gray-400">Ciclo</th>
            <th class="px-5 py-3 font-medium text-gray-500 text-start text-theme-xs dark:text-gray-400">Empresas</th>
            <th class="px-5 py-3 font-medium text-gray-500 text-start text-theme-xs dark:text-gray-400">Activo</th>
            <th class="px-5 py-3 font-medium text-gray-500 text-center text-theme-xs dark:text-gray-400">Acciones</th>
          </tr>
        </thead>

        <!-- Table Body -->
        <tbody class="divide-y divide-gray-100 dark:divide-white/[0.05]">
          @if (contactos.length === 0 && !loading) {
          <tr>
            <td colspan="9" class="px-5 py-8 text-center">
              <div class="flex flex-col items-center gap-2 text-gray-500 dark:text-gray-400">
                <svg class="w-12 h-12" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="1"
                    d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z">
                  </path>
                </svg>
                <span>No hay contactos que coincidan con los filtros</span>
              </div>
            </td>
          </tr>
          }

          @for (contacto of contactos; track contacto.id) {
          <tr [ngClass]="{'bg-brand-50/30 dark:bg-brand-900/10': isContactSelected(contacto.id)}">
            <td class="px-4 py-3 text-center">
              <input type="checkbox"
                class="w-4 h-4 text-brand-500 bg-white border-gray-300 rounded focus:ring-brand-500 dark:border-gray-600 dark:bg-gray-700 cursor-pointer"
                [checked]="isContactSelected(contacto.id)"
                (change)="toggleContactSelection(contacto.id)">
            </td>
            <td class="px-4 py-3 text-gray-500 text-start text-theme-sm dark:text-gray-400">
              <span class="block font-medium text-gray-800 dark:text-white/90">
                {{ contacto.fullname }}{{ contacto.lastname ? ' ' + contacto.lastname : '' }}
              </span>
            </td>
            <td class="px-4 py-3 text-gray-500 text-start text-theme-sm dark:text-gray-400">
              {{ contacto.mail }}
            </td>
            <td class="px-4 py-3 text-gray-500 text-start text-theme-sm dark:text-gray-400">
              <span class="inline-flex items-center gap-2">
                @if (countryFlagCode(contacto.phone); as cc) {
                  <span class="fi fi-{{ cc }} rounded-sm shrink-0" [title]="countryName(contacto.phone)"></span>
                }
                <span>{{ contacto.phone || '-' }}</span>
              </span>
            </td>
            <td class="px-4 py-3 text-gray-500 text-start text-theme-sm dark:text-gray-400">
              <app-badge [color]="'info'">
                {{ getContactStateName(contacto.idContactState) }}
              </app-badge>
            </td>
            <td class="px-4 py-3 text-gray-500 text-start text-theme-sm dark:text-gray-400">
              <app-badge [color]="'success'">
                {{ getCycleName(contacto.idContactCycle) }}
              </app-badge>
            </td>
            <td class="px-4 py-3 text-start text-theme-sm">
              @if (contacto.companies && contacto.companies.length > 0) {
                <div class="flex flex-wrap gap-1">
                  @for (company of contacto.companies; track company.id) {
                    <span class="inline-block px-2 py-0.5 rounded-full text-xs font-medium bg-gray-100 text-gray-700 dark:bg-gray-700 dark:text-gray-300">
                      {{ company.commercialName }}
                    </span>
                  }
                </div>
              } @else {
                <span class="text-gray-400 dark:text-gray-500">—</span>
              }
            </td>

            <td class="px-4 py-3 text-start text-theme-sm">
              @if (contacto.isActive === false) {
                <span class="inline-flex items-center px-2 py-0.5 rounded-full text-xs font-medium bg-warning-100 text-warning-700 dark:bg-warning-500/20 dark:text-warning-400">
                  Inactivo
                </span>
              } @else {
                <span class="inline-flex items-center px-2 py-0.5 rounded-full text-xs font-medium bg-success-100 text-success-700 dark:bg-success-500/20 dark:text-success-400">
                  Activo
                </span>
              }
            </td>

            <td class="px-4 py-3 text-gray-500 text-center text-theme-sm dark:text-gray-400">
              <div class="flex items-center justify-center gap-2">
                @if (contacto.mail) {
                <button (click)="enviarCorreo(contacto)"
                  class="rounded-lg p-2 hover:bg-sky-50 hover:text-sky-600 dark:hover:bg-sky-900/20 dark:hover:text-sky-400 transition-colors"
                  title="Enviar correo">
                  <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                      d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"></path>
                  </svg>
                </button>
                }
                <button (click)="verDetalle(contacto)"
                  class="rounded-lg p-2 hover:bg-brand-50 hover:text-brand-600 dark:hover:bg-brand-900/20 dark:hover:text-brand-400 transition-colors"
                  title="Ver detalle">
                  <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                      d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"></path>
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                      d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z">
                    </path>
                  </svg>
                </button>
                <button (click)="editarContacto(contacto)"
                  *appHasPermission="'contacts:edit'"
                  class="rounded-lg p-2 hover:bg-gray-100 dark:hover:bg-white/[0.05] transition-colors"
                  title="Editar">
                  <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                      d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z">
                    </path>
                  </svg>
                </button>
                @if (filtroIsActive) {
                <button (click)="archivarContacto(contacto)"
                  class="rounded-lg p-2 hover:bg-warning-50 hover:text-warning-600 transition-colors"
                  title="Inactivar">
                  <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                      d="M5 8h14M5 8a2 2 0 110-4h14a2 2 0 110 4M5 8v10a2 2 0 002 2h10a2 2 0 002-2V8m-9 4h4">
                    </path>
                  </svg>
                </button>
                } @else {
                <button (click)="restaurarContacto(contacto)"
                  class="rounded-lg p-2 hover:bg-success-50 hover:text-success-600 transition-colors"
                  title="Reactivar">
                  <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                      d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15">
                    </path>
                  </svg>
                </button>
                <button (click)="desvincularYEliminarContacto(contacto)"
                  *appHasPermission="'contacts:delete'"
                  class="rounded-lg p-2 hover:bg-error-50 hover:text-error-600 transition-colors"
                  title="Desvincular y eliminar">
                  <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                      d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16">
                    </path>
                  </svg>
                </button>
                }
              </div>
            </td>
          </tr>
          }
        </tbody>
      </table>
    </div>

    <!-- Paginación -->
    @if (globalTotalPages >= 1) {
    <div class="mt-4 border-t border-gray-200 dark:border-gray-700 pt-4 px-5 pb-4">
      <div class="flex items-center justify-between gap-4 flex-wrap">
        <div class="flex items-center gap-2">
          <span class="text-sm text-gray-500 dark:text-gray-400">{{ globalTotalElements }} registros</span>
          <select [ngModel]="pageSize" (ngModelChange)="changePageSize($event)"
            class="px-2 py-1.5 text-sm rounded-lg border border-gray-300 dark:border-gray-600
                   bg-white dark:bg-gray-800 text-gray-900 dark:text-white
                   focus:ring-2 focus:ring-brand-500 focus:border-transparent">
            @for (opt of PAGE_SIZE_OPTIONS; track opt) {
              <option [value]="opt">{{ opt }}</option>
            }
          </select>
        </div>
        <div class="flex items-center gap-2">
          <button type="button" (click)="cambiarPagina(globalPage - 1)" [disabled]="!hasPrevPage"
            class="px-3 py-1.5 text-sm rounded-lg border border-gray-300 dark:border-gray-600
                   bg-white dark:bg-gray-800 text-gray-700 dark:text-gray-300
                   hover:bg-gray-50 dark:hover:bg-gray-700
                   disabled:opacity-40 disabled:cursor-not-allowed transition-colors">
            Anterior
          </button>
          <div class="flex items-center gap-1.5">
            <span class="text-sm text-gray-500 dark:text-gray-400">Página</span>
            <select [ngModel]="pageDisplay" (ngModelChange)="cambiarPagina($event - 1)"
              class="px-2 py-1.5 text-sm rounded-lg border border-gray-300 dark:border-gray-600
                     bg-white dark:bg-gray-800 text-gray-900 dark:text-white
                     focus:ring-2 focus:ring-brand-500 focus:border-transparent">
              @for (p of pagesArray; track p) {
                <option [value]="p">{{ p }}</option>
              }
            </select>
            <span class="text-sm text-gray-500 dark:text-gray-400">de {{ globalTotalPages }}</span>
          </div>
          <button type="button" (click)="cambiarPagina(globalPage + 1)" [disabled]="!hasNextPage"
            class="px-3 py-1.5 text-sm rounded-lg border border-gray-300 dark:border-gray-600
                   bg-white dark:bg-gray-800 text-gray-700 dark:text-gray-300
                   hover:bg-gray-50 dark:hover:bg-gray-700
                   disabled:opacity-40 disabled:cursor-not-allowed transition-colors">
            Siguiente
          </button>
        </div>
      </div>
    </div>
    }
  </div>
  }
</div>

<!-- Modal de detalle -->
<app-contacto-detail-modal
  [isOpen]="showDetailModal"
  [contact]="selectedContact"
  [contactStates]="contactStates"
  [contactCycles]="contactCycles"
  [contactOrigins]="contactOrigins"
  (close)="cerrarModal()">
</app-contacto-detail-modal>

<!-- Modal Importar / Exportar (permiso granular por pestaña) -->
<app-import-export-modal
  [isOpen]="showImportExportModal"
  initialTab="contacts"
  (close)="cerrarImportExport()">
</app-import-export-modal>

<!-- Modal de acción masiva -->
@if (isBulkActionModalOpen) {
<div class="fixed inset-0 z-modal-top flex items-center justify-center bg-black/50" (click)="closeBulkActionModal()">
  <div class="bg-white dark:bg-gray-900 rounded-2xl shadow-xl w-full max-w-md p-6 mx-4" (click)="$event.stopPropagation()">

    <!-- Estado: confirmación -->
    @if (!bulkResult) {
    <div>
      <div class="text-center">
        <div class="w-14 h-14 rounded-full flex items-center justify-center mx-auto mb-4"
          [ngClass]="bulkAction === 'DELETE' ? 'bg-red-50 dark:bg-red-900/20'
                   : bulkAction === 'ARCHIVE' ? 'bg-amber-50 dark:bg-amber-900/20'
                   : 'bg-brand-50 dark:bg-brand-900/20'">
          <svg class="w-7 h-7"
            [ngClass]="bulkAction === 'DELETE' ? 'text-red-500'
                     : bulkAction === 'ARCHIVE' ? 'text-amber-500'
                     : 'text-brand-500'"
            fill="none" stroke="currentColor" viewBox="0 0 24 24">
            @if (bulkAction === 'CHANGE_OWNER') {
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z"/>
            } @else {
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-2.5L13.732 4c-.77-.833-1.964-.833-2.732 0L4.082 16.5c-.77.833.192 2.5 1.732 2.5z"/>
            }
          </svg>
        </div>
        <h3 class="text-lg font-bold text-gray-900 dark:text-white mb-2">
          {{ getBulkActionLabel(bulkAction) }}
        </h3>
        <p class="text-sm text-gray-500 dark:text-gray-400 mb-4">
          @if (bulkAction === 'CHANGE_OWNER') {
            Elige el nuevo responsable para
            <strong>{{ selectedContactIds.length }}</strong> contacto(s).
          }
          @if (bulkAction === 'ARCHIVE') {
            ¿Inactivar <strong>{{ selectedContactIds.length }}</strong> contacto(s)?
            No aparecerán en los procesos activos del sistema. Podrás reactivarlos después.
          }
          @if (bulkAction === 'DELETE') {
            ¿Eliminar permanentemente <strong>{{ selectedContactIds.length }}</strong> contacto(s)?
            Se desvincularán de sus campañas de marketing y empresas antes de eliminarse.
            Esta acción no se puede deshacer.
          }
        </p>
      </div>

      <!-- Picker de responsable (solo CHANGE_OWNER) -->
      @if (bulkAction === 'CHANGE_OWNER') {
      <div class="mb-6 text-left">
        <label class="block text-xs font-medium text-gray-700 dark:text-gray-300 mb-1">Nuevo responsable</label>
        <app-entity-select
          [searchFn]="userSearch"
          [labelFn]="userLabel"
          [sublabelFn]="userSublabel"
          [value]="bulkOwnerId"
          (valueChange)="onBulkOwnerChange($event)"
          placeholder="Buscar por nombre o correo…">
        </app-entity-select>
      </div>
      }

      <div class="flex justify-center gap-3">
        <button (click)="closeBulkActionModal()"
          class="px-4 py-2.5 text-sm font-medium text-gray-700 dark:text-gray-300 bg-gray-100 dark:bg-gray-800 rounded-xl hover:bg-gray-200 dark:hover:bg-gray-700 transition-colors">
          Cancelar
        </button>
        <button (click)="ejecutarAccionMasiva()"
          [disabled]="isExecutingBulk || (bulkAction === 'CHANGE_OWNER' && !bulkOwnerId)"
          [ngClass]="bulkAction === 'DELETE' ? 'bg-red-500 hover:bg-red-600'
                   : bulkAction === 'ARCHIVE' ? 'bg-amber-500 hover:bg-amber-600'
                   : 'bg-brand-500 hover:bg-brand-600'"
          class="inline-flex items-center gap-2 px-4 py-2.5 text-sm font-medium text-white rounded-xl transition-colors disabled:opacity-50 disabled:cursor-not-allowed">
          @if (isExecutingBulk) {
            <div class="animate-spin rounded-full h-4 w-4 border-b-2 border-white"></div>
          }
          Confirmar
        </button>
      </div>
    </div>
    }

    <!-- Estado: resultado -->
    @if (bulkResult) {
    <div>
      <div class="text-center">
        <div class="w-14 h-14 rounded-full flex items-center justify-center mx-auto mb-4"
          [ngClass]="bulkResult.failed === 0 ? 'bg-emerald-50 dark:bg-emerald-900/20' : 'bg-amber-50 dark:bg-amber-900/20'">
          <svg class="w-7 h-7" [ngClass]="bulkResult.failed === 0 ? 'text-emerald-500' : 'text-amber-500'"
            fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"/>
          </svg>
        </div>
        <h3 class="text-lg font-bold text-gray-900 dark:text-white mb-4">
          {{ bulkResult.failed === 0 ? 'Acción completada' : 'Acción completada parcialmente' }}
        </h3>
      </div>

      <div class="grid grid-cols-2 gap-3 mb-4">
        <div class="bg-gray-50 dark:bg-gray-800 rounded-xl p-3 text-center">
          <p class="text-xl font-black text-gray-800 dark:text-gray-200">{{ bulkResult.processed }}</p>
          <p class="text-[10px] font-bold text-gray-500 uppercase tracking-wide mt-1">Procesados</p>
        </div>
        <div class="bg-red-50 dark:bg-red-900/20 rounded-xl p-3 text-center">
          <p class="text-xl font-black text-red-600 dark:text-red-400">{{ bulkResult.failed }}</p>
          <p class="text-[10px] font-bold text-red-500 uppercase tracking-wide mt-1">Fallidos</p>
        </div>
      </div>

      @if (bulkResult.failures.length > 0) {
      <div class="mb-4 max-h-48 overflow-y-auto rounded-xl border border-red-100 dark:border-red-900/40">
        <ul class="divide-y divide-red-100 dark:divide-red-900/40">
          @for (f of bulkResult.failures; track f.id) {
          <li class="px-3 py-2 text-left">
            <p class="text-xs font-semibold text-gray-700 dark:text-gray-300">{{ getFailureName(f) }}</p>
            <p class="text-xs text-red-600 dark:text-red-400">{{ f.reason }}</p>
          </li>
          }
        </ul>
      </div>
      }

      <button (click)="closeBulkActionModal()"
        class="w-full px-4 py-2.5 text-sm font-medium text-white bg-brand-500 rounded-xl hover:bg-brand-600 transition-colors">
        Cerrar
      </button>
    </div>
    }

  </div>
</div>
}
